<template>
  <div :class="$style.mainContainer">
    <aw-cms-card
      v-for="tile in content.components"
      :key="tile.id"
      :content="{...tile, backgroundColor: {hex: $styleVariables[backgroundColor], alpha: 1 }}"
      tile-type="verticalTile"
      :class="$style.tile"
      :analytics-banner-interaction="analyticsBannerInteraction"
      :analytics-measurable="analyticsMeasurable"
    />
  </div>
</template>

<script>
  import analyticsBannerInteractionMixin from '~~/common/mixins/analyticsBannerInteractionMixin.js';
  import { defineAsyncComponent } from 'vue';

  export default {
    name: 'AwVerticalTiles',
    components: {
      AwCmsCard: defineAsyncComponent(() => import('~~/common/components/AwStandardPartials/AwCmsCard')),
    },
    mixins: [analyticsBannerInteractionMixin],
    props: {
      content: {
        type: Object,
        required: true,
      },
      backgroundColor: {
        type: String,
        default: 'colorBackground3',
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.mainContainerMobile {

  @include mobile(max) {
    .tile:last-of-type {
      width: 216px;

      [data-cms-card-content] {
        margin-right: 16px;
      }
    }
  }
}

.mainContainer {
  display: grid;

  width: 100%;
  height: 100%;
  column-gap: 8px;
  row-gap: 32px;

  grid-template-columns: repeat(2, 1fr);

  @include desktop-small(min) {
    column-gap: 32px;
    row-gap: 40px;
    grid-template-columns: repeat(3, 1fr);
  }
}

.tile {
  > [data-cms-card-content] {
    width: 100%;

    picture {
      width: calc(100% + 48px);
    }
  }
}
</style>
